import React, {useState, useEffect} from 'react'
import operatorContext from './operatorContext'
import axios from 'axios'


const OperatorState = props => {


    const [operator, setOperator] = useState({

        loading: "d-flex",
        userInfo: null,
        current: null,
        error: null,
        transactions: [],
        jobHistory: [],
        banks: [],
        userBank: [],
        skills: [],
        operatorSkills: [],
        allJobs: [],
        pendingJobs: [],
        acceptedJobs: [],
        rejectedJobs: [],
        startedJobs: [],
        completedJobs: [],
        rejectionList: [],
        isAvailable: 0,
        message: {
            msg: "",
            msg_options: ""
        },
        logged_in: localStorage.getItem('al2'),
        side_bar_toggle: ""
    })

    //Get userInfo
    var userInformation = JSON.parse(localStorage.getItem('userInfo'))

    //Set userinfo
    useEffect(() => {

        userInformation &&
        setOperator({
            ...operator,
            userInfo: userInformation
        })
        //eslint-disable-next-line
    }, []);

    const baseUrl = 'https://hailing-backend-app.azurewebsites.net/';
    // const baseUrl = "https://hailing-backend.herokuapp.com";
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    let authorization;
    if(userInfo !== null) authorization = userInfo.authorization

    //Set up axios headers
    const authAxios = axios.create({
        headers: {
            'Content-Type': 'multipart/form-data',
            'authorization': authorization
        },
        validateStatus: () => true
    })

    //All operator functions
    const acceptNewJob = async job_id => {
        try {
            const res = await authAxios.put(`${baseUrl}/user/operator/job/accepted/${job_id}`)

            setOperator({
                loading: false,
                ...operator,
                acceptedJobs: res.data.data,
                message: {
                    msg: `${res.data.message}`,
                    msg_options: {
                        type: 'success',
                        position: "bottom right"
                    }
                },
            })

            return res;

        } catch (error) {
            setOperator({
                ...operator,
                loading: false,
                error: error.response && error.response.data.detail
                    ? error.response.data.detail
                    : error.message,
            })
        }
    }

    const addOperatorBankDetails = async bank_details => {

        try {
            const res = await authAxios.post(`${baseUrl}/generic/add_bank`, bank_details)

            setOperator({
                loading: false,
                ...operator,
                userBank: res.data.data,
                message: {
                    msg: `${res.data.message}`,
                    msg_options: {
                        type: 'success',
                        position: "bottom right"
                    }
                },
            })

            return res;

        } catch (error) {
            setOperator({
                ...operator,
                loading: false,
                error: error.response && error.response.data.detail
                    ? error.response.data.detail
                    : error.message,
            })
        }
    }

    const addOperatorSkills = async skills => {

        try {

            const res = await authAxios.post(`${baseUrl}/user/operator/add_operator_skills`, skills)

            setOperator({
                loading: false,
                ...operator,
                operatorSkills: res.data.data,
                message: {
                    msg: `${res.data.message}`,
                    msg_options: {
                        type: 'success',
                        position: "bottom right"
                    }
                },
            })

            return res;

        } catch (error) {
            setOperator({
                ...operator,
                loading: false,
                error: error.response && error.response.data.detail
                    ? error.response.data.detail
                    : error.message,
            })
        }
    }

    const clearAlert = () => {
        setOperator({
            ...operator,
            message: {
                msg: "",
                msg_options: {
                    type: '',
                    position: ""
                }
            }
        })
    }

    const clearPageLoading = () => {
        setOperator({
            ...operator,
            loading: "d-none",
        })
    }

    const deleteJob = () => {
        console.log("delete job")
    }

    const getAcceptedJobs = async () => {

        try {
            const res = await authAxios.get(`${baseUrl}/user/operator/jobs/accepted_jobs`)

            setOperator({
                loading: false,
                ...operator,
                acceptedJobs: res.data.data,
            })
        } catch (error) {
            setOperator({
                ...operator,
                error: error
            })

        }
    }

    const getBanks = async () => {

        try {
            const res = await authAxios.get(`${baseUrl}/generic/get_banks`)

            setOperator({
                loading: false,
                ...operator,
                banks: res.data.data.data,
            })
        } catch (error) {
            setOperator({
                ...operator,
                error: error
            })

        }
    }


    const getAllSkills = async () => {

        try {
            const res = await authAxios.get(`${baseUrl}/user/operator/get_skills`)

            setOperator({
                loading: false,
                ...operator,
                skills: res.data.data,
            })
            return res.data.data
        } catch (error) {
            setOperator({
                ...operator,
                error: error
            })

        }
    }

    const getAvailabilityStatus = async () => {

        try {
            const res = await authAxios.get(`${baseUrl}/user/operator/get_availability`)

            setOperator({
                loading: false,
                ...operator,
                isAvailable: res.data.data.status

            })
        } catch (error) {
            setOperator({
                ...operator,
                error: error
            })

        }
    }

    const getJobHistory = () => {
        console.log("get job history");
    }


    const getOperatorSkills = async () => {

        try {
            const res = await authAxios.get(`${baseUrl}/user/operator/get_operator_skills`)
            await setOperator({
                loading: false,
                ...operator,
                operatorSkills: res.data.data,
            })
            return res.data.data
        } catch (error) {
            setOperator({
                ...operator,
                error: error
            })

        }
    }

    const getNewJobs = async () => {

        try {
            const res = await authAxios.get(`${baseUrl}/user/operator/jobs/all`)

            setOperator({
                loading: false,
                ...operator,
                allJobs: res.data.data,
            })
        } catch (error) {
            setOperator({
                ...operator,
                error: error
            })

        }
    }
    const getPendingJobs = async () => {

        try {
            const res = await authAxios.get(`${baseUrl}/user/operator/jobs/pending`)

            setOperator({
                loading: false,
                ...operator,
                pendingJobs: res.data.data,

            })
        } catch (error) {
            setOperator({
                ...operator,
                error: error
            })

        }
    }

    const getRejectionList = async () => {

        try {
            const res = await authAxios.get(`${baseUrl}/user/operator/job/rejection_reasons_list`)

            setOperator({
                loading: false,
                ...operator,
                rejectionList: res.data.data,

            })
        } catch (error) {
            setOperator({
                ...operator,
                error: error
            })

        }
    }

    const deleteTransaction = () => {
        console.log("delete transaction")
    }

    const getRejectedJobs = async () => {

        try {
            const res = await authAxios.get(`${baseUrl}/user/operator/jobs/rejected_jobs`)

            setOperator({
                loading: false,
                ...operator,
                rejectedJobs: res.data.data,
            })
        } catch (error) {
            setOperator({
                ...operator,
                error: error
            })

        }
    }

    const getTransactions = () => {
        console.log("get transactions");
    }

    const getUserBank = async () => {

        try {
            const res = await authAxios.get(`${baseUrl}/generic/get_user_bank`)

            setOperator({
                loading: false,
                ...operator,
                userBank: res.data.data,
            })
        } catch (error) {
            setOperator({
                ...operator,
                error: error
            })

        }
    }

    const jobStarted = async job_id => {

        try {
            const res = await authAxios.put(`${baseUrl}/user/operator/job/started/${job_id}`)

            setOperator({
                loading: false,
                ...operator,
                startedJobs: res.data.data,
                message: {
                    msg: `${res.data.message}`,
                    msg_options: {
                        type: 'success',
                        position: "bottom right"
                    }
                },
            })

            return res;

        } catch (error) {
            setOperator({
                ...operator,
                loading: false,
                error: error.response && error.response.data.detail
                    ? error.response.data.detail
                    : error.message,
            })
        }
    }
    const jobCompleted = async job_id => {

        try {
            const res = await authAxios.put(`${baseUrl}/user/operator/job/completed/${job_id}`)

            setOperator({
                loading: false,
                ...operator,
                completedJobs: res.data.data,
                message: {
                    msg: `${res.data.message}`,
                    msg_options: {
                        type: 'success',
                        position: "bottom right"
                    }
                },
            })

            return res;

        } catch (error) {
            setOperator({
                ...operator,
                loading: false,
                error: error.response && error.response.data.detail
                    ? error.response.data.detail
                    : error.message,
            })
        }
    }

    const logout = async () => {
        localStorage.removeItem('userInfo')
        localStorage.removeItem('al2')

        setOperator({
            ...operator,
            message: {
                msg: "Logged out successfully!",
                msg_options: {
                    type: 'success',
                    position: "bottom right"
                }
            },
            logged_in: false
        })
    }

    const rejectNewJob = async job_id => {
        try {
            var id = job_id.id;
            const res = await authAxios.put(`${baseUrl}/user/operator/job/rejected/${id}`)
            setOperator({
                loading: false,
                ...operator,
                rejectedJobs: res.data.data,
                message: {
                    msg: `${res.data.message}`,
                    msg_options: {
                        type: 'success',
                        position: "bottom right"
                    }
                },
            })

            return res;

        } catch (error) {
            setOperator({
                ...operator,
                loading: false,
                error: error.response && error.response.data.detail
                    ? error.response.data.detail
                    : error.message,
            })
        }
    }


    //Set Loading
    const setLoading = () => {
        setOperator({
            ...operator,
            loading: true,
        })
    }

    const toggleAvailability = async status => {

        try {

            const res = await authAxios.put(`${baseUrl}/user/operator/availability/${status}`)

            setOperator({

                ...operator,
                loading: false,
                message: {
                    msg: `${res.data.message}`,
                    msg_options: {
                        type: 'success',
                        position: "bottom right"
                    }
                },

            })

        } catch (error) {
            setOperator({
                ...operator,
                loading: false,
                message: {
                    msg: `${error.message}`,
                    msg_options: {
                        type: 'danger',
                        position: "bottom right"
                    }
                },
                error: error.response && error.response.data.detail
                    ? error.response.data.detail
                    : error.message,
            })
        }
    }

    const toggle_sidebar = () => {
        if (operator.side_bar_toggle === "") {
            setOperator({
                ...operator,
                side_bar_toggle: "toggled"
            })
        } else {
            setOperator({
                ...operator,
                side_bar_toggle: ""
            })
        }

    }

    const updateOperatorProfile = async (user) => {
        try {
            const res = await authAxios.put(`${baseUrl}/auth/user/update/profile`, user)

            setOperator({
                loading: false,
                ...operator,
                userInfo: res.data,
                message: {
                    msg: `${res.data.message}`,
                    msg_options: {
                        type: 'success',
                        position: "bottom right"
                    }
                },
            })

        } catch (error) {
            setOperator({
                ...operator,
                loading: false,
                error: error.response && error.response.data.detail
                    ? error.response.data.detail
                    : error.message,
            })
        }
    }

    const updateOperatorPassword = async (password) => {

        try {
            const res = await authAxios.put(`${baseUrl}/auth/user/update/password`, password)

            setOperator({
                loading: false,
                message: {
                    msg: `${res.data.message}`,
                    msg_options: {
                        type: 'success',
                        position: "bottom right"
                    }
                },
            })

            return res;

        } catch (error) {
            setOperator({
                ...operator,
                loading: false,
                error: error.response && error.response.data.detail
                    ? error.response.data.detail
                    : error.message,
            })
        }
    }

    const updateOperatorBankDetails = async (bank_details) => {

        try {
            const res = await authAxios.put(`${baseUrl}/generic/update_bank`, bank_details)

            setOperator({
                loading: false,
                ...operator,
                userBank: res.data.data,
                message: {
                    msg: `${res.data.message}`,
                    msg_options: {
                        type: 'success',
                        position: "bottom right"
                    }
                },
            })

            return res;

        } catch (error) {
            setOperator({
                ...operator,
                loading: false,
                error: error.response && error.response.data.detail
                    ? error.response.data.detail
                    : error.message,
            })
        }
    }


    return <operatorContext.Provider
        value={{
            operator,
            acceptNewJob,
            addOperatorSkills,
            clearAlert,
            clearPageLoading,
            deleteJob,
            deleteTransaction,
            getAcceptedJobs,
            getAllSkills,
            getAvailabilityStatus,
            getBanks,
            getJobHistory,
            getNewJobs,
            getOperatorSkills,
            getPendingJobs,
            getRejectedJobs,
            getRejectionList,
            getTransactions,
            getUserBank,
            jobStarted,
            jobCompleted,
            logout,
            rejectNewJob,
            setLoading,
            toggleAvailability,
            toggle_sidebar,
            updateOperatorProfile,
            updateOperatorPassword,
            updateOperatorBankDetails,
            addOperatorBankDetails

        }}>
        {props.children}
    </operatorContext.Provider>
}

export default OperatorState;